import React from "react";

/**
 * Decorative gradient blob backdrop echoing the brand's molecular motif.
 * Positioned absolute; parent should be relative + overflow-hidden.
 */
export const BlobBackdrop = ({ className = "", variant = "default" }) => {
  const variants = {
    default: (
      <>
        <div
          className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full blur-3xl opacity-30 animate-blob"
          style={{
            background:
              "radial-gradient(circle at 30% 30%, #4f46e5, transparent 60%)",
          }}
        />
        <div
          className="absolute top-1/3 -right-32 w-[520px] h-[520px] rounded-full blur-3xl opacity-25 animate-blob"
          style={{
            background:
              "radial-gradient(circle at 60% 40%, #9333ea, transparent 60%)",
            animationDelay: "2s",
          }}
        />
        <div
          className="absolute -bottom-32 left-1/4 w-[460px] h-[460px] rounded-full blur-3xl opacity-25 animate-blob"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, #ec4899, transparent 60%)",
            animationDelay: "4s",
          }}
        />
      </>
    ),
    subtle: (
      <>
        <div
          className="absolute -top-32 right-0 w-[360px] h-[360px] rounded-full blur-3xl opacity-15 animate-blob"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, #6366f1, transparent 60%)",
          }}
        />
        <div
          className="absolute -bottom-24 -left-24 w-[420px] h-[420px] rounded-full blur-3xl opacity-15 animate-blob"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, #d946ef, transparent 60%)",
            animationDelay: "3s",
          }}
        />
      </>
    ),
  };

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {variants[variant] || variants.default}
    </div>
  );
};

export default BlobBackdrop;
